/** Map credit report sidebar routes to in-page section tabs (no refetch on navigation). */

export const CREDIT_REPORT_TAB_PATHS = {
  potentially_negative: '/credit-report/negative',
  accounts: '/credit-report/positive',
  inquiries: '/credit-report/inquiries',
  public_records: '/credit-report/public-records',
  personal_info: '/credit-report/personal',
  creditor_contacts: '/credit-report',
};

export const CREDIT_REPORT_PATH_TABS = {
  '/credit-report/negative': 'potentially_negative',
  '/credit-report/positive': 'accounts',
  '/credit-report/inquiries': 'inquiries',
  '/credit-report/public-records': 'public_records',
  '/credit-report/personal': 'personal_info',
  '/credit-report/addresses': 'personal_info',
  '/credit-report/employment': 'personal_info',
  '/credit-report/closed': 'accounts',
  '/credit-report': 'potentially_negative',
};

export function creditReportTabFromPathname(pathname = '') {
  return CREDIT_REPORT_PATH_TABS[pathname] || 'potentially_negative';
}

export function creditReportPathForTab(tabId) {
  return CREDIT_REPORT_TAB_PATHS[tabId] || '/credit-report/negative';
}
